'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $is_Lapp_data_AppAuthData$GeneralPracticeUser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_data_AppAuthData$GeneralPracticeUser)));
}
export { $is_Lapp_data_AppAuthData$GeneralPracticeUser as $is_Lapp_data_AppAuthData$GeneralPracticeUser };
function $isArrayOf_Lapp_data_AppAuthData$GeneralPracticeUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$GeneralPracticeUser)));
}
export { $isArrayOf_Lapp_data_AppAuthData$GeneralPracticeUser as $isArrayOf_Lapp_data_AppAuthData$GeneralPracticeUser };
//# sourceMappingURL=app.data.-App-Auth-Data$-General-Practice-User.js.map
